<div class="loading-container block-background">
    <div class="loader"></div>
</div>
